module.exports = __webpack_public_path__ + "static/img/contact-bg.daa13c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact-bg.png
// module id = kPnq
// module chunks = 0